function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default {
  methods: {
    $_updateSyncedPropsFabric: function $_updateSyncedPropsFabric(prop, data) {
      var _this = this;

      return function () {
        _this.propsIsUpdating[prop] = true;
        var info = typeof data === "function" ? data() : data;
        return _this.$emit("update:".concat(prop), info);
      };
    },
    $_bindPropsUpdateEvents: function $_bindPropsUpdateEvents() {
      var _this2 = this;

      var syncedProps = [{
        events: ["moveend"],
        prop: "center",
        getter: this.map.getCenter.bind(this.map)
      }, {
        events: ["zoomend"],
        prop: "zoom",
        getter: this.map.getZoom.bind(this.map)
      }, {
        events: ["rotate"],
        prop: "bearing",
        getter: this.map.getBearing.bind(this.map)
      }, {
        events: ["pitch"],
        prop: "pitch",
        getter: this.map.getPitch.bind(this.map)
      } // TODO: make 'bounds' synced prop
      // { events: ['moveend', 'zoomend', 'rotate', 'pitch'], prop: 'bounds', getter: this.map.getBounds.bind(this.map) }
      ];
      syncedProps.forEach(function (_ref) {
        var events = _ref.events,
            prop = _ref.prop,
            getter = _ref.getter;
        events.forEach(function (event) {
          if (_this2.$listeners["update:".concat(prop)]) {
            _this2.map.on(event, _this2.$_updateSyncedPropsFabric(prop, getter));
          }
        });
      });
    },
    $_loadMap: function $_loadMap() {
      var _this3 = this;

      return this.mapboxPromise.then(function (mapbox) {
        _this3.mapbox = mapbox.default ? mapbox.default : mapbox;
        return new Promise(function (resolve) {
          if (_this3.accessToken) _this3.mapbox.accessToken = _this3.accessToken;
          var map = new _this3.mapbox.Map(_objectSpread(_objectSpread({}, _this3._props), {}, {
            container: _this3.$refs.container,
            style: _this3.mapStyle
          }));
          map.on("load", function () {
            return resolve(map);
          });
        });
      });
    },
    $_RTLTextPluginError: function $_RTLTextPluginError(error) {
      this.$emit("rtl-plugin-error", {
        map: this.map,
        error: error
      });
    },
    $_bindMapEvents: function $_bindMapEvents(events) {
      var _this4 = this;

      Object.keys(this.$listeners).forEach(function (eventName) {
        if (events.includes(eventName)) {
          _this4.map.on(eventName, _this4.$_emitMapEvent);
        }
      });
    },
    $_unbindEvents: function $_unbindEvents(events) {
      var _this5 = this;

      events.forEach(function (eventName) {
        _this5.map.off(eventName, _this5.$_emitMapEvent);
      });
    }
  }
};